import _extends from "@babel/runtime/helpers/esm/extends";
import { proxy } from '../valtio';
import deepMerge from 'deepmerge';
export const createProxy = (initialState, overrideState) => {
  const deepMergedState = deepMerge(initialState, _extends({}, overrideState));
  return proxy(_extends({
    __isProxy: true
  }, deepMergedState));
};